export default __webpack_public_path__ + "static/media/banna-spray-paints.7864aefe.webp";